export default "__VITE_ASSET__36cc4129__"